import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type NavLink = { to: string; label: string };

type Props = {
    title: string;
    subtitle?: string;
    actions?: ReactNode;
    links?: NavLink[];
    children: ReactNode;
};

/** Same page chrome as Domain Category / internal admin report listings. */
const RbacPageShell = ({ title, subtitle, actions, links, children }: Props) => (
    <div className="main flex-1">
        <section className="updateadditionalinformation">
            <div className="container max-1140 px-lg-0 overflow-hidden">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="white-block white-block-notopborderradius p-0 h-100">
                            <div className="p-4 p-md-5">
                                <div className="alumni_statistics">
                                    <div className="row g-2 align-items-start mb-3">
                                        <div className="col">
                                            <h2 className="font-26 font-600 mb-0 pb-2">{title}</h2>
                                            {subtitle ? <p className="text-muted mb-0 font-14">{subtitle}</p> : null}
                                            {links && links.length ? (
                                                <div className="d-flex flex-wrap gap-3 mt-2">
                                                    {links.map((link) => (
                                                        <Link key={link.to} to={link.to} className="font-14">
                                                            {link.label}
                                                        </Link>
                                                    ))}
                                                </div>
                                            ) : null}
                                        </div>
                                        {actions ? <div className="col-auto">{actions}</div> : null}
                                    </div>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
);

export default RbacPageShell;
